export const groups = [
  { label: 'Cliente - Pessoa Física', value: 'PHYSICAL' },
  { label: 'Cliente - Pessoa Jurídica', value: 'LEGAL' },
];
